import './style.css';
import { Game } from './game/Game';

const container = document.getElementById('app')!;
new Game(container);
